import * as React from "react";
import styled, { css } from "styled-components";

import { colors } from "../../common/utils/style";
import Link from "../../common/components/router/Link";

interface Props {
  message: string;
  subMessage?: string;
  buttonText: string;
  onClick?: () => void;
  linkPath?: string;
  inAppLink?: boolean;
  targetBlank?: boolean;
}

const StartActionCard: React.SFC<Props> = props => {
  const { message, subMessage, buttonText, linkPath, inAppLink, targetBlank, onClick } = props;
  // TODO(stomk): nl2br subMessage

  return (
    <Base>
      <Left>
        <Message>{message}</Message>
        {subMessage && <SubMessage>{subMessage}</SubMessage>}
      </Left>
      <>
        {onClick && <Button onClick={onClick}>{buttonText}</Button>}
        {linkPath &&
          (inAppLink ? (
            <InAppLinkButton to={linkPath}>{buttonText}</InAppLinkButton>
          ) : (
            <LinkButton href={linkPath} target={targetBlank ? "_blank" : "_self"}>
              {buttonText}
            </LinkButton>
          ))}
      </>
    </Base>
  );
};

const Base = styled.div`
  width: 600px;
  margin: 0 auto;
  padding: 24px 30px;
  border-radius: 12px;
  background-color: #fafafa;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Left = styled.div`
  width: 370px;
`;

const Message = styled.div`
  font-weight: 600;
  font-size: 22px;
  line-height: 1;
  color: ${colors.gray4};
`;

const SubMessage = styled.p`
  margin-top: 8px;
  font-size: 13px;
  color: ${colors.gray2};
  line-height: 1.38;
  letter-spacing: 0.5px;
`;

const ButtonBase = css`
  min-width: 138px;
  height: 33px;
  border-radius: 60px;
  padding: 0 20px;
  font-weight: 600;
  font-size: 13px;
  line-height: 33px;
  text-align: center;
  background-color: #21bddb; /* blue400 */
  color: white;
  transition: background-color 0.2s;

  &:hover {
    background-color: #00aed1; /* blue500 */
  }
  &:focus {
    outline: none;
  }
`;

const Button = styled.button`
  ${ButtonBase};
  border: none;
`;

const LinkButtonBase = css`
  ${ButtonBase};
  display: block;
  box-sizing: border-box;
  &:hover {
    text-decoration: none;
  }
`;

const LinkButton = styled.a`
  ${LinkButtonBase};
`;

const InAppLinkButton = styled(Link)`
  ${LinkButtonBase};
`;

export default StartActionCard;



// WEBPACK FOOTER //
// ./frontend/src/companies/components/StartActionCard.tsx